import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaSearch, FaUser, FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';

function Header() {
    const { user, isAuthenticated, logout } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [showUserMenu, setShowUserMenu] = useState(false);

    const isActive = (path) => location.pathname === path;

    const handleLogout = () => {
        logout();
        setShowUserMenu(false);
        navigate('/', { replace: true });
    };

    return (
        <header className="site-header">
            <div className="container">
                <div className="header-inner">
                    {/* Logo */}
                    <Link to="/" className="brand">
                        <img src={logo} alt="NutriLens" />
                        <div>
                            <div className="name">NUTRILENS</div>
                            <div className="tag hidden-sm">Bring your nutrition into focus</div>
                        </div>
                    </Link>

                    {/* Right side menu (desktop) */}
                    <nav className="menu-right">
                        <Link to="/" className={isActive('/') ? 'active' : ''}>Home</Link>
                        <Link to="/homechefs" className={isActive('/homechefs') ? 'active' : ''}>Home Chefs</Link>
                        <Link to="/feed" className={isActive('/feed') ? 'active' : ''}>Recipes</Link>
                        <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact</Link>
                        {isAuthenticated ? (
                            <div style={{ position: 'relative' }}>
                                <button onClick={() => setShowUserMenu(!showUserMenu)} className="btn btn-primary" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <img src={user?.avatar} alt={user?.username} style={{ width: 24, height: 24, borderRadius: '999px' }} />
                                    <span className="hidden-sm">{user?.username}</span>
                                </button>
                                {showUserMenu && (
                                    <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}
                                        className="dropdown" style={{ position: 'absolute', right: 0, marginTop: 8, width: 200, background: '#fff', color: '#111', borderRadius: 10, boxShadow: '0 12px 24px rgba(0,0,0,.12)', padding: 8 }}>
                                        <button onClick={handleLogout} className="btn btn-danger btn-block" style={{ borderRadius: 10 }}>Logout</button>
                                    </motion.div>
                                )}
                            </div>
                        ) : (
                            <Link to="/login" className="btn btn-primary">Join Now</Link>
                        )}
                    </nav>

                    {/* Mobile Menu Button */}
                    <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="burger" aria-label="Menu">
                        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
                    </button>
                </div>

                {/* Mobile Navigation */}
                {isMobileMenuOpen && (
                    <motion.nav initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} className="nav" style={{ paddingTop: 16, borderTop: '1px solid rgba(255,255,255,0.2)' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <Link to="/" className={isActive('/') ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
                            <Link to="/homechefs" className={isActive('/homechefs') ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Home Chefs</Link>
                            <Link to="/feed" className={isActive('/feed') ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Recipes</Link>
                            <Link to="/contact" className={isActive('/contact') ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Contact</Link>
                        </div>
                    </motion.nav>
                )}
            </div>
        </header>
    );
}

export default Header;